import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-job-offer-dialog',
  templateUrl: './job-offer-dialog.component.html',
  standalone: false,
})
export class JobOfferDialogComponent {
  @Input() jobOffer: any;
  @Input() visible = false;
  @Output() closed = new EventEmitter<void>();

  seccionesJustificacion: { [key: string]: string } = {};

  ngOnChanges() {
    const justificacion = this.jobOffer?.justificacion?.justificacion_extendida;

    if (typeof justificacion !== 'string') {
      this.seccionesJustificacion = {};
      return;
    }

    if (justificacion.trim() === '') {
      this.seccionesJustificacion = {};
      return;
    }

    this.parseJustificacion(justificacion);
  }
  

  parseJustificacion(justificacion: string) {
    const secciones = [
      'OBLIGATORIOS',
      'EXPERIENCIA',
      'FORMACI[ÓO]N',
      'COMPETENCIAS',
      'VALORACI[ÓO]N GENERAL'
    ];

    const resultado: Record<string, string> = {};

    secciones.forEach((sec, i) => {
      const nextSec = secciones[i + 1];

      const regex = nextSec
        ? new RegExp(`${sec}\\s*([\\s\\S]*?)(?=${nextSec})`) 
        : new RegExp(`${sec}\\s*([\\s\\S]*)`);

      const match = justificacion.match(regex);
      let texto = match?.[1]?.trim() ?? '';

      texto = texto.replace(/[#:]/g, '').trim();

      resultado[sec.replace(/\[ÓO\]/, 'Ó')] = texto;
    });

    this.seccionesJustificacion = resultado;
  }

  capitalizeFirstLetter(value: string): string {
      if (!value) return '';
          return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  closeDialog(): void {
    this.visible = false;
    this.closed.emit();
  }
}
